import type { TFunction } from "i18next";
import { useRef, type RefObject } from "react";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import U2000InputText from "../../../../../u2000Core/components/formControls/input/U2000InputText";
import type { U3143CadastreHandler } from "./U3143CadastreHandlers";

// Component props interface
interface U3143CadastreDlgProps {
  u3143CadastreHandler: U3143CadastreHandler;
  t: TFunction;
  NS: string;
}

// Dialog component for editing cadastres
function U3143CadastreEditDlg({ u3143CadastreHandler, t, NS }: U3143CadastreDlgProps) {
  const { formStateHandlers } = u3143CadastreHandler;

  // Ref for the cadastre code input to be used as default focus
  const cadastreCodeRef = useRef<HTMLInputElement>(null);

  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    if (action === "cancel") {
      // Temporarily disable onBlur validation to prevent unwanted validation on cancel
      const originalOnBlur = formStateHandlers.onBlur;
      formStateHandlers.onBlur = () => {
        /* Ignore onBlur during cancel */
      };

      // Close dialog immediately without validation
      u3143CadastreHandler.onDlgClose("cancel");

      // Restore original onBlur handler after dialog closes
      setTimeout(() => {
        formStateHandlers.onBlur = originalOnBlur;
      }, 0);
    } else if (action === "save") {
      // Normal save flow with validation
      u3143CadastreHandler.onDlgClose("save");
    }
  };

  // render
  return (
    <U2000SaveCancelDialog
      isOpen={u3143CadastreHandler.isDialogOpen}
      onClose={handleClose}
      title={t("lblCadastre", { ns: NS })}
      isValid={true}
      defaultFocusRef={cadastreCodeRef as RefObject<HTMLElement>}
    >
      <div className="flex flex-col gap-y-4">
        <div>
          <U2000InputText
            fieldName="cadastreCode"
            label={t("lblCadastreCode", { ns: NS })}
            formStateHandlers={formStateHandlers}
            inputRef={cadastreCodeRef as React.RefObject<HTMLInputElement>}
          />
        </div>
        <div>
          <U2000InputText fieldName="cadastre" label={t("lblCadastre", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
        <div>
          <U2000InputText fieldName="rankCode" label={t("lblRankCode", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
        <div>
          <U2000InputText fieldName="rankLabel" label={t("lblRankLabel", { ns: NS })} formStateHandlers={formStateHandlers} />
        </div>
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U3143CadastreEditDlg;
